import React from 'react';
import { compose } from 'redux';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import VRAPendingRow from './VRAPendingRow';

const VRAPendingList = props => {
  const { actionHandler, VRAsPending } = props;

  const vraPendingRow = VRAPendingRow(actionHandler);
  const vraPendingHeaderRow = (
    <Table.Row>
      <Table.HeaderCell>VRA</Table.HeaderCell>
      <Table.HeaderCell>VIN</Table.HeaderCell>
      <Table.HeaderCell>Dealer Number</Table.HeaderCell>
      <Table.HeaderCell>Dealer Name</Table.HeaderCell>
      <Table.HeaderCell>Return Location</Table.HeaderCell>
      <Table.HeaderCell>Status</Table.HeaderCell>
      <Table.HeaderCell>Vehicle Price</Table.HeaderCell>
      <Table.HeaderCell>Return Initiated At</Table.HeaderCell>
      <Table.HeaderCell>Return Expiration Date</Table.HeaderCell>
      <Table.HeaderCell>Pending Reason</Table.HeaderCell>
      <Table.HeaderCell>Return Initiated By</Table.HeaderCell>
      <Table.HeaderCell>Action</Table.HeaderCell>
    </Table.Row>
  );
  const emptyRow = (
    <Table.Row>
      <Table.Cell colSpan='13' textAlign='center'>No VRAs in Pending status</Table.Cell>
    </Table.Row>
  );

  return (
    <div>
      <Table
        celled
        padded
        renderBodyRow={isEmpty(VRAsPending) ? () => emptyRow : vraPendingRow}
        tableData={isEmpty(VRAsPending) ? [{}] : VRAsPending}
        headerRow={vraPendingHeaderRow}
        size='small'
        striped
        compact='very'
        style={{ fontSize: '90%' }}
      />
    </div>
  );
};

VRAPendingList.propTypes = {
  actionHandler: PropTypes.func.isRequired,
  VRAsPending: PropTypes.arrayOf(PropTypes.object),
  // onSelectHandler: PropTypes.func,
  user: PropTypes.shape({}),
};

export default compose(
  withApollo,
  withRouter
)(VRAPendingList);
